import React, { useState } from 'react'

import { Box, TextField } from '@material-ui/core'

import useJourneyWhiteLabel from 'hooks/useJourneyWhiteLabel'
import useSnackbar from 'hooks/useSnackbar'
import useGovernanceProjectNameDpo from 'hooks/useGovernanceProjectNameDpo'

import helpers from 'helpers'

import useStyles from './styles'

const CompanyConsult = () => {
  const styles = useStyles()
  const snackbar = useSnackbar()

  const { setCurrentStep } = useJourneyWhiteLabel()
  const { setLoading, governanceProjectCompany, loadGovernanceProjectCompany } =
    useGovernanceProjectNameDpo()

  const [cnpj, setCnpj] = useState(
    governanceProjectCompany?.company?.document || '',
  )
  const [error, setError] = useState('')

  const handleChange = (event) => {
    if (!!error) {
      setError('')
    }
    setCnpj(helpers.formatters.cnpj(event.target.value))
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    if (!helpers.validates.cnpj.isValid(cnpj)) {
      setError('CNPJ inválido.')
      return
    }

    setLoading(true)
    try {
      const response = await loadGovernanceProjectCompany(cnpj)

      if (!!response) {
        setCurrentStep((prevStep) => prevStep + 1)
      }
    } catch (error) {
      console.error('Error submitting CNPJ:', error)
      snackbar.open({
        message: helpers.formatters.errorMessage(error),
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <Box
      className={styles.boxInput}
      component="form"
      id="name-dpo-form"
      mb={2}
      onSubmit={handleSubmit}
    >
      <TextField
        value={cnpj}
        onChange={handleChange}
        label="Informe o CNPJ"
        error={!!error}
        helperText={error}
        required
        fullWidth
      />
    </Box>
  )
}

export default CompanyConsult
